<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="shop.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
                @blur="$emit('on-name-change', shop.name)"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="terminal">Terminal</label>

            <v-select
                v-model="shop.terminal"
                label="text"
                :options="paymentMethodOptions"
                :reduce="option => option.value"
                :clearable="false"
                :searchable="false"
                placeholder="Select terminal"
                :class="{ 'is-invalid': hasError('terminal') }"
            />

            <div class="invalid-feedback">
                {{ getError('terminal') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label>Pay with stars?</label>
            <b-form-checkbox v-model="shop.payWithStars" switch />
        </div>
    </div>
</template>

<script>
import { PaymentMethodOptions } from '@/enums/paymentMethods';

export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            shop: {}
        };
    },

    computed: {
        paymentMethodOptions() {
            return PaymentMethodOptions;
        }
    },

    watch: {
        shop() {
            this.$emit('input', this.shop);
        }
    },

    mounted() {
        this.shop = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.shop[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.shop,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
